module.exports = __webpack_public_path__ + "static/47-deepfake-april2020-7b4f326ab4d942c885bdfdaa381a583e.jpg";